import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/client/favoris')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/client/favoris"!</div>
}
